import React from 'react';
import { Form } from 'react-bootstrap';
import ServiceCalls from '../utils/serviceCalls.js';
import CryptoJS from 'crypto-js';
const CommonUtils = {
    formatDate: function (dateString, includeTime = false) {
        try {
            if (!dateString) {
                return new Date().toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }
            else {
                //Set all times to UTC
                if (dateString.toLowerCase().indexOf('z') === -1) {
                    dateString += "Z";
                }

                if (includeTime) {
                    const date = new Date(dateString);
                    const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
                    const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
                    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
                    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
                    return `${formattedDate} ${formattedTime}`;
                }

                return new Date(dateString).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' })
            }

        } catch (e) {
            console.log(`Util function error.  formatDate ex: ${e}`);
            return null;
        }

    },
    formatAmount: function (amtString) {
        try {
            if (amtString === null) {
                return (Number.parseFloat(0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }
            else {
                return (Number.parseFloat(amtString).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
            }

        } catch (e) {
            console.log(`Util function error.  formatAmount ex: ${e}`);
            return "";
        }
    },
    validateBasicEmail: function (email) {
        const re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9].:+)\])/i;
        var isAllowed = false;
        if (email) {
            //Test for multiple @ characters
            if ((email.split("@").length - 1) == 1) {
                isAllowed = re.test(email);
            }
        }
        return isAllowed;
    },
    validateEmail: function (email, spuaEmail) {
        const re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9].:+)\])/i;

        if (email) {
            if (re.test(email)) {
                //Check Email Domains
                var isAllowed = false;
                //Test for multiple @ characters
                if ((email.split("@").length - 1) === 1) {
                    var eDomain = email.toLowerCase().split('@')[1];
                    var deniedDomains = ['uhg.com', 'uhc.com', 'optum.com'];
                    if (deniedDomains.indexOf(eDomain) === -1) {
                        //SPUA
                        if (spuaEmail) {
                            var spuaDomain = spuaEmail.toLowerCase().split('@')[1];
                            var genericDomains = ['yahoo.com', 'gmail.com', 'hotmail.com', 'aol.com', 'outlook.com'];
                            //9-13 If SPUA has generic email allow any email
                            if (genericDomains.indexOf(spuaDomain) >= 0) {
                                return true;
                            } else {
                                //SPUA does not have a generic email. Do not allow new user to have one.
                                return (genericDomains.indexOf(eDomain) === -1);
                            }
                        }
                        else {
                            isAllowed = true;
                        }
                    }
                }
                return isAllowed;
            }
        }
        return false;
    },
    statusDisplayforDropDown: function (status, canView, registration, callBack) {
        if (!status && registration.statusId === 4 && registration.inviteStatus === "NOT_RESPONDED") {
            return (<div className="title-select-access">
                <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                    <Form.Control disabled value="Pending" as="select" name="statusSel">
                        <option value="">Pending</option>
                    </Form.Control>
                </Form.Group>
            </div>);
        }
        else if (registration.statusId === 5 && registration.inviteStatus === "REGISTERED") {
            //Registered - base display on status
            if (canView) {
                return (
                    <div className="title-select-access">
                        <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                            <Form.Control value={status} as="select" name="statusSel" onChange={(e) => callBack(e)}>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </Form.Control>
                        </Form.Group>
                    </div>
                );
            } else {
                return (
                    <div className="title-select-access">
                        <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                            <Form.Control disabled value={status.toString()} as="select" name="statusSel">
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </Form.Control>
                        </Form.Group>
                    </div>
                );
            }
        }
        else {
            //Invalid status
            return (<div className="title-select-access">
                <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                    <Form.Control disabled value="Invalid" as="select" name="statusSel">
                        <option value="">New</option>
                    </Form.Control>
                </Form.Group>
            </div>);
        }
    },
    statusDisplayforToggle: function (status, canView, registration, callBack, isLocked) {
        //Handle Locked user first
        if (isLocked !== undefined && isLocked) {
            return (<div className="title-select-access">
                <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                    <Form.Control disabled value="Locked" as="select" name="statusSel">
                        <option value="">Locked</option>
                    </Form.Control>
                </Form.Group>
            </div>);
        }
        else if (!status && registration.statusId === 4 && registration.inviteStatus === "NOT_RESPONDED") {
            return (<div className="title-select-access">
                <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                    <Form.Control disabled value="Pending" as="select" name="statusSel">
                        <option value="">Pending</option>
                    </Form.Control>
                </Form.Group>
            </div>);
        }
        else if (registration.statusId === 5 && registration.inviteStatus === "REGISTERED") {
            //Registered - base display on status


            //if (canView) {
            return (
                //<div className="title-select-access">
                //    <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                //        <Form.Control value={status} as="select" name="statusSel" onChange={(e) => callBack(e)}>
                //            <option value="true">Active</option>
                //            <option value="false">Inactive</option>
                //        </Form.Control>
                //    </Form.Group>
                //</div>
                <Form.Group as="div" className="adminStatusCtrl" controlId="userEnabled">
                    <Form.Switch
                        type="switch"
                        id="contactStatus"
                        className="userStatusOption"
                        disabled={!canView}
                        checked={status}
                        onChange={(e) => callBack(e)}
                    />
                </Form.Group>
            );
            //} else {
            //    return (
            //        <div className="title-select-access">
            //            <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
            //                <Form.Control disabled value={status.toString()} as="select" name="statusSel">
            //                    <option value="true">Active</option>
            //                    <option value="false">Inactive</option>
            //                </Form.Control>
            //            </Form.Group>
            //        </div>
            //    );
            //}
        }
        else {
            //Invalid status
            return (<div className="title-select-access">
                <Form.Group md={1} className="dropdown-bar" style={{ paddingTop: '5px' }}>
                    <Form.Control disabled value="Invalid" as="select" name="statusSel">
                        <option value="">New</option>
                    </Form.Control>
                </Form.Group>
            </div>);
        }
    },
    statusDisplayforForm: function (status, canView, registration, callBack) {
        if (!status && registration.statusId === 4 && registration.inviteStatus === "NOT_RESPONDED") {
            return (
                <select disabled={true} style={{ marginLeft: "50px" }} value="Pending" name="statusSel">
                    <option value="">Pending</option>
                </select>
            );
        }
        else if (registration.statusId === 5 && registration.inviteStatus === "REGISTERED") {
            //Registered - base display on status
            if (canView) {
                return (
                    <select disabled={false} style={{ marginLeft: "50px" }} value={status.toString()} name="statusSel" onChange={(e) => callBack(e)}>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                );
            } else {
                return (
                    <select disabled={true} style={{ marginLeft: "50px" }} value={status.toString()} name="statusSel">
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                    </select>
                );
            }
        }
        else {
            //Invalid status
            return (
                <select disabled={true} style={{ marginLeft: "50px" }} value="Invalid" name="statusSel">
                    <option value="">New</option>
                </select>
            );
        }
    },
    renderStatusDate: function (sDate) {
        //If null date in database, return --
        if (!sDate) {
            return (
                "--"
            );
        }
        return (
            this.formatDate(sDate)
        );
    },
    statusName: function (user) {
        if (user.contact) {
            if (!user.enabled && user.contact.registration.statusId === 4 && user.contact.registration.inviteStatus === "NOT_RESPONDED") {
                return "Pending";
            }
            else if (user.contact.registration.statusId === 5 && user.contact.registration.inviteStatus === "REGISTERED") {
                return (user.enabled) ? "Active" : "Inactive";
            }
            else {
                return "New";
            }
        }
        else {
            return "No Contact";
        }

    },
    statusNameForContact: function (contact) {

        if (contact) {
            //Have INACTIVE Roles supersede others
            if (this.determineContactDisabled(contact)) {
                return "Disabled";
            }
            //US7652820 - Disable Roles if user has locked account
            if (this.determineContactLocked(contact)) {
                return "Locked";
            }
            // US9826347 Resend status (statusId = 10)
            if (contact.ohcidRegistration.statusId === 10) {
                return "Resend";
            }
            if (!contact.profileStatus && contact.ohcidRegistration.statusId === 4 && contact.ohcidRegistration.inviteStatus === "NOT_RESPONDED") {
                return "Pending";
            }
            else if (contact.ohcidRegistration.statusId === 5 && contact.ohcidRegistration.inviteStatus === "REGISTERED") {
                return (contact.profileStatus) ? "Active" : "Inactive";
            }
            else {
                return "New";
            }
        }
        else {
            return "No Contact";
        }
    },
    determineContactLocked: function (contact) {
        //Determine Contact type
        if (contact.suppliers && contact.suppliers[0].contactRoles) {
            return contact.suppliers[0].contactRoles.find(r => r.roleId === 6 && r.enabled === true);
        }
        else if (contact.roles) {
            return contact.roles.find(r => r.roleId === 6 && r.enabled === true);
        }
        else {
            return (true);
        }
    },
    determineContactDisabled: function (contact) {
        //Determine Contact type
        if (contact.suppliers && contact.suppliers[0].contactRoles) {
            return contact.suppliers[0].contactRoles.find(r => r.roleId === 7); // DE1064285 - Removed enabled check - Show disabled if they have the Role
        }
        else if (contact.roles) {
            return contact.roles.find(r => r.roleId === 7); // DE1064285 - Removed enabled check - Show disabled if they have the Role
        }
        else {
            return (true);
        }
    },
    determineInactiveContactRoleName: function (contact) {
        //Determine Contact type
        if (contact.suppliers && contact.suppliers[0].contactRoles) {
            if (contact.suppliers[0].contactRoles.find(r => r.roleId === 7)) { // DE1064285 - Removed enabled check - Show disabled if they have the Role
                return 'Disabled';
            }
            else if (contact.suppliers[0].contactRoles.find(r => r.roleId === 6)) { // DE1064285 - Removed enabled check - Show disabled if they have the Role
                return 'Locked';
            }
            else { return ''; }
        }
        else if (contact.roles) {
            if (contact.roles.find(r => r.roleId === 7)) {// DE1064285 - Removed enabled check - Show disabled if they have the Role
                return 'Disabled';
            }
            else if (contact.roles.find(r => r.roleId === 6)) { // DE1064285 - Removed enabled check - Show disabled if they have the Role
                return 'Locked';
            }
            else { return ''; }
        }
        else {
            return (true);
        }
    },
    statusNameForOHCIDDetails: function (registration, isSPUA = false) {
        if (registration) {
            if (registration.statusId === 4 || registration.statusId === 5) {
                if (isSPUA && registration.statusId === 4 && registration.inviteMessages === "ADMIN_INVITE") {
                    return "SPUA Invite";
                }
                else {
                    return "Not New";
                }
            }
            else {
                return "New";
            }
        }
        else {
            return "No Registration";
        }
    },
    buildRoleList: function (roles) {
        /*var roleArr = [];*/

    },
    getSearchResults: function (results, page, pageSize) {
        //Determine current page based on number of results
        if (!results) {
            return [];
        }
        //DEBUG console.log(`In getSearchResults ${results.length} and max result count ${(page * pageSize)} for current page ${page}`);
        var prevPage = (page - 1);
        var startIdx = (page === 1) ? 0 : (pageSize * prevPage);
        var endIdx = ((page * pageSize) > results.length) ? results.length : (page * pageSize);
        //DEBUG console.log(`Fetching page result Start Idx ${startIdx} and End Idx: ${endIdx}`);
        var resultArr = results.slice(startIdx, endIdx);
        //DEBUG console.log(`Fetching page result count of ${resultArr.length} for Page: ${page} and a PageSize: ${pageSize}`);
        return resultArr;
    },
    prepSearchExport: function (columns, searchResults) {

        if (!searchResults) {
            return [];
        }

        var colArr = [];
        var nameLoop = columns.map(item => {
            const obj = {};
            obj["name"] = item["name"].props.title;
            return obj["name"];
        })
        colArr.push(nameLoop);

        var colIdArr = [];
        //var idLoop = columns.map(item => {
        //    colIdArr.push(item["id"]);
        //    return item["id"];
        //});

        var arrangedData = [];
        arrangedData.push(colArr[0]);
        for (var i = 0; i < searchResults.length; i++) {
            var dataRow = searchResults[i];
            //console.log(`Current Row ${JSON.stringify(dataRow)}`);
            var itemRow = [];
            for (var x = 0; x < colIdArr.length; x++) {
                // console.log("Current col " + colIdArr[x]);
                for (let key in dataRow) {
                    if (key === colIdArr[x]) {
                        var dataVal = dataRow[key];
                        //console.log(`Row ${i}  Col ${x} Col name ${key} with val ${dataVal}`);
                        itemRow.push(dataVal)
                    }
                }
            }
            arrangedData.push(itemRow);
        }
        return arrangedData;
    },
    determineVendorCurrencyCode: function (vendorData) {
        //Check for Payment info
        if (vendorData.vendorPayments.length === 0) {
            return '';
        }
        else if (vendorData.vendorPayments[0].effStatus === 'A') {
            //return currency code if populated
            if (vendorData.vendorPayments[0].paymentCurrencyCode) {
                return vendorData.vendorPayments[0].paymentCurrencyCode;
            }
            //If no currency code and vendersetId is UHGID, return USD
            else if (vendorData.vendorSetId === 'UHGID') {
                return 'USD';
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    },
    determineVendorPersistence: function (persistenceChar) {
        switch (persistenceChar) {
            case 'R':
                return 'Regular';
            case 'P':
                return 'Permanent';
            case 'S':
                return 'Single Payment Supplier';
            case 'O':
                return 'One Time';
            default:
                return ' - ';
        }
    },
    determineIfVendorIsEMEAPlus: function (vendorData) {
        //Check for Payment info
        if (vendorData.vendorPayments && vendorData.vendorPayments.length === 0) {
            //NO PAYMENT RECORD
            return (vendorData.vendorSetId !== 'UHGID');
        }
        else if (vendorData.vendorPayments && vendorData.vendorPayments[0].paymentMethod === "WIR") {
            // WIR PAYMENT IS ALWAYS EMEA+
            return (true);
        }
        else {
            // NOT WIR PAYMENT BASED ON SET ID
            return (vendorData.vendorSetId !== 'UHGID');;
        }

    },
    determineVendorBankNumberLabel: function (country, paymentMethod, dfiQual) {
        if (country && paymentMethod) {
            switch (country.toUpperCase()) {
                case "AUS":
                    if (paymentMethod === "WIR") {
                        return (dfiQual === "BP") ? "Registration Number" : "Account Number";
                    }
                    else {
                        return "Account Number";
                    }

                default:
                    return "Account Number";
            }
        }
        else {
            //International WIR template
            return "MISSING DATA";
        }
    },
    determineVendorBankRoutingLabel: function (dfiQual) {
        if (dfiQual) {
            switch (dfiQual.toUpperCase()) {
                case "01":
                    return "Routing Number";
                case "02":
                    return "Swift/BIC";
                case "04":
                    return "Canada Bank Branch/Institute";
                case "BP":
                    return "Biller Code";
                case "UI":
                    return "IFSC Code";
                default:
                    return "";
            }
        }
        else {
            //Empty Quailifier from an EMEA supplier
            return "Swift/BIC";
        }
    },
    determineEMEAVendorBankRoutingLabel: function (country, paymentMethod, dfiQual) {
        if (country && paymentMethod) {
            switch (country.toUpperCase()) {
                case "AUS":
                    if (paymentMethod === "WIR") {
                        return (dfiQual === "BP") ? "Biller Code" : "Swift/BIC";
                    }
                    else {
                        return "Swift/BIC";
                    }
                case "GBR":
                    return "Swift/BIC";
                case "IRL":
                    return "Swift/BIC";
                case "TZA":
                    return "Swift/BIC";
                case "UGA":
                    return "Swift/BIC";
                default:
                    return this.determineVendorBankRoutingLabel(dfiQual);
            }
        }
        else {
            //International WIR template
            return "Invalid EMEA Country";
        }
    },
    determineVendorContactRegionLabel: function (currentCountry) {
        return (currentCountry) ? (currentCountry.stateAvailable === 'Y') ? currentCountry.regionLabel.trim() : 'State' : 'State';
    },
    determineEMEABankIDLabel: function (currentCountry) {
        if (currentCountry) {
            switch (currentCountry.toUpperCase()) {
                case "GBR":
                    return "Sort Code";
                case "AUS":
                    return "Bank ID";
                case "IRL":
                    return "Sort Code";
                case "TZA":
                    return "Routing Code";
                case "UGA":
                    return "Routing Code";
                default:
                    return "Bank Code";
            }
        }
        else {
            return "Sort Code";
        }
    },
    determineEMEABankIDValue: function (currentBank) {
        if (currentBank.country && currentBank.ibanId) {
            var bankId = '';
            if (currentBank.country === "GBR" || currentBank.country === "IRL") {
                bankId = (currentBank.ibanId.length > 14) ? currentBank.ibanId.substring(8, 14) : "Invalid Length";
                //DEBUG console.log(`Returning Sort code ${bankId} for country ${currentBank.country} and IBAN ${currentBank.ibanId}`);
            }
            else {
                //Other countries logic
                bankId = (currentBank.ibanId.length > 14) ? currentBank.ibanId.substring(9, 14) : "Invalid Length";
                //DEBUG console.log(`Returning BSB code ${bankId} for country ${currentBank.country} and IBAN ${currentBank.ibanId}`);
            }
            return bankId;
        }
        else {
            return "Invalid BanK ID";
        }
    },
    extractIBANFields: function (iban, ibanValidator) {
        //Create Object to hold extracts
        try {
            let ibanObj = {
                countryCode: (iban) ? iban.substring(0, 2) : "",
                ibanCheckDigit: (iban) ? iban.substring(2, 4) : "",
                bankAccountNumber: (iban) ? this.substringIBAN(iban, ibanValidator.ibanAccountPos, ibanValidator.ibanAccountLen, ibanValidator.ibanAccountPad) : "",
                bankId: (iban) ? this.substringIBAN(iban, ibanValidator.ibanBankIdPos, ibanValidator.ibanBankIdLen, ibanValidator.ibanBankIdPad) : "",
                branchId: (iban) ? this.substringIBAN(iban, ibanValidator.ibanBranchIdPos, ibanValidator.ibanBranchIdLen, ibanValidator.ibanBranchIdPad) : "",
                checkDigit: (iban) ? this.substringIBAN(iban, ibanValidator.ibanChkDigitPos, ibanValidator.ibanChkDigitLen, "N") : "",
                dfiIdNumber: (iban) ? this.substringIBAN(iban, ibanValidator.ibanDfiIdPos, ibanValidator.ibanDfiIdLen, ibanValidator.ibanDfiIdPad) : "",
            };
            return ibanObj;
        } catch (e) {
            console.log(`Error extracting IBAN fields ${e}`);
            return null;
        }
    },
    validateIBAN: function (iban) {
        let id = iban;
        let len = id.length;
        let mod = "";
        let i = 0;

        id = id.substring(4) + id.substring(0, 4);
        id = this.convIbanAlpha(id);

        if (len > 34) {
            //throw new Error("IBAN must be less than 34 characters.");
            return false;
        } else {
            if (!this.isNumber(id)) {
                // throw new Error("IBAN contains invalid characters.");
                return false;
            } else {
                len = id.length;
                while (i < len) {
                    mod += id.substring(i, i + 9); // Process in smaller chunks
                    mod = (parseInt(mod) % 97).toString();
                    i += 9;
                }
                return (parseInt(mod) === 1);
                //if (parseInt(mod) !== 1) {
                //    // throw new Error("Invalid IBAN checksum.");
                //    return false;
                //}
            }
        }
    },
    determineVendorContactCityLabel: function (currentCountry) {
        return (currentCountry) ? (currentCountry.cityAvailable === 'Y') ? currentCountry.cityLabel.trim() : "City" : 'City';
    },
    determineVendorRegionAvailable: function (currentCountry) {
        return (currentCountry) ? currentCountry.stateAvailable === 'Y' : false;
    },
    determineVendorCityAvailable: function (currentCountry) {
        return (currentCountry) ? (currentCountry.cityAvailable === 'Y') : false;
    },
    determineVendorPostalAvailable: function (currentCountry) {
        return (currentCountry) ? (currentCountry.postalAvailable === 'Y') : false;
    },
    determineEMEADFIQualifier: function (currentDfiNumber, currentDfiQualifier) {
        //DE992153
        //        For EMEA + suppliers...in all cases, with one exception of course HA!,
        //    If the new request has DFI_Number populated, then we should send DFI_Qualifier = '02'
        //If the new request has DFI_Number =[blank], then we should send DFI_Qualifier =[blank]
        //Exception:
        //        If existing DFI_Qual = 'BP', then when new request, send DFI_Qual ='BP'        
        var newDfiQualifier = (currentDfiNumber && currentDfiNumber.length > 0) ? "02" : "";
        newDfiQualifier = (currentDfiQualifier === "BP") ? currentDfiQualifier : newDfiQualifier;
        return newDfiQualifier;
    },
    getCurrentSupplier(currentSupplierId, currentUser) {
        var curSup = {};
        if (currentUser) {
            currentUser.suppliers.forEach(function (supplier) {
                if (supplier.supplierId === currentSupplierId) {
                    curSup = supplier;
                    return false;
                }
            });
        }
        return curSup;
    },
    sortRemitAddresses: function (addresses) {
        addresses.sort(function (a, b) {
            const a1 = (a.addressSequenceNumber) ? Number(a.addressSequenceNumber) : 0;
            const b1 = (b.addressSequenceNumber) ? Number(b.addressSequenceNumber) : 0;
            return a1 - b1;
        });
        //5-16 decision to sort by address seq ASC
        //var defIdx = addresses.findIndex(e => e.defaultAddress === 'Y');
        // if (defIdx > -1) {
        //    arrayMove(addresses, defIdx, 0);
        // }
        return addresses;
    },
    capitalizeFirstLetter: function (string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    determineRegistrationStatus: function (registrationStatusId) {
        switch (registrationStatusId) {
            case 1:
                return 'NOT SENT';
            case 2:
                return 'REGISTRATION SENT';
            case 3:
                return 'ALREADY REGISTERED';
            case 4:
                return 'INVITED';
            case 5:
                return 'REGISTERED';
            case 6:
                return 'DISABLED';
            case 7:
                return 'OTHER';
            case 8:
                return 'NOT RESPONDED';
            case 9:
                return 'SHARED EMAIL';
            default:
                return '';
        }
    },
    customStringSort: function (rowA, rowB, getValue) {
        const valueA = (getValue(rowA)) ? getValue(rowA).toLowerCase() : '';
        const valueB = (getValue(rowB)) ? getValue(rowB).toLowerCase() : '';
        return valueA.localeCompare(valueB);
    },
    //DE1395741 Sorts suppliers alphabetically by name, falling back to vendorId when names match.
    compareSuppliersBySupplierName: function (a, b) {
        const supplierNameA = (a.supplierName || '').toLowerCase();
        const supplierNameB = (b.supplierName || '').toLowerCase();
        if (supplierNameA < supplierNameB) return -1;
        if (supplierNameA > supplierNameB) return 1;

        const vendorIdA = (a.vendorId || '').toString().toLowerCase();
        const vendorIdB = (b.vendorId || '').toString().toLowerCase();
        if (vendorIdA < vendorIdB) return -1;
        if (vendorIdA > vendorIdB) return 1;

        return 0;
    },
    determineIfTimeWithinRange: function (evalTime, rangeInMinutes) {
        var updateTime = (evalTime.indexOf('Z') > -1) ? evalTime : evalTime + 'Z';
        var reqTime = new Date(new Date(updateTime).toLocaleString());
        const currTime = new Date();
        var reqTimeInSec = reqTime.getTime();
        var currTimeInSec = currTime.getTime();
        var diffInSeconds = (currTimeInSec - reqTimeInSec) / 1000;
        var isInTimeFrame = diffInSeconds <= (rangeInMinutes * 60);  //comnpare against an hour
        //DEBUG  console.log(`Checking for recent approved requests = Req Time: ${reqTime} (in Seconds: ${reqTimeInSec})  and Current time: ${currTime} (in Seconds: ${currTimeInSec}) - Diff in Seconds is ${diffInSeconds}  is in Range: ${isInTimeFrame}`);
        return isInTimeFrame;
    },
    buildPayeeSelections: function (supplierList) {
        var groupedArr = this.groupBy(supplierList, supplier => supplier.vendorSetId);
        var vendorSetIdArr = Array.from(groupedArr, ([name, value]) => ({ name, value }))
        var sortedArr = [];
        vendorSetIdArr.forEach((item) => {
            var sortedSups = item.value.sort(this.compareSuppliersBySupplierName);
            var supObj = {
                vendorSetId: item.name,
                suppliers: sortedSups
            }
            sortedArr.push(supObj);
        });

        //Sort all
        sortedArr = sortedArr.sort(function (a, b) { return (a.vendorSetId > b.vendorSetId ? 1 : (a.vendorSetId === b.vendorSetId ? 0 : -1)) });
        //Put UHGID in first position
        var ughItem = sortedArr.find(s => s.vendorSetId === "UHGID");
        if (ughItem) {
            sortedArr.splice(sortedArr.indexOf(ughItem), 1);
            sortedArr.splice(0, 0, ughItem);
        }

        return sortedArr;
    },
    generatePrivacyPolicyUrl: function () {
        var randomStr = new Date().toISOString().substring(0, 10);
        return "https://www.uhc.com/content/dam/uhcdotcom/en/npp/OSPP-ENTERPRISE-SUPPLIER-PORTAL-EN.pdf?=" + randomStr;
    },
    generateTOSUrl: function () {
        var randomStr = new Date().toISOString().substring(0, 10);
        return "https://www.uhc.com/content/dam/uhcdotcom/en/npp/TOU-ENTERPRISE-SUPPLIER-PORTAL-EN.pdf?=" + randomStr;
    },
    determineSupplierCommentType: function (supplierAdminCommentTypeId) {
        switch (supplierAdminCommentTypeId) {
            case 0:
                return "Unknown";
            case 1:
                return "Maintenance Enabled";
            case 2:
                return "Maintenance Disabled";
            default:
                return "N/A";
        }
    }
    ,
    groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    },
    maskBankString: str => (str.length < 3) ? "" : "*".repeat(str.length - 3) + str.slice(-3),
    substringIBAN(id, pos, len, pad) {
        let result = id.substring(pos - 1, pos - 1 + len);
        if (pad === "Y") {
            result = result.padStart(len, '0');
        }
        return result;
    },
    convIbanAlpha(iban) {
        const alphabet = {
            A: "10", B: "11", C: "12", D: "13", E: "14", F: "15", G: "16", H: "17", I: "18", J: "19",
            K: "20", L: "21", M: "22", N: "23", O: "24", P: "25", Q: "26", R: "27", S: "28", T: "29",
            U: "30", V: "31", W: "32", X: "33", Y: "34", Z: "35"
        };
        return iban.split('').map(char => alphabet[char] || char).join('');
    },
    isNumber(str) {
        return /^\d+$/.test(str);
    },
    decryptData(encryptedData, secretKey) {
        // Key and IV must match the C# values
        const key = CryptoJS.enc.Utf8.parse(secretKey);
        const iv = CryptoJS.enc.Utf8.parse("\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0"); // 16 zero bytes
        // Decrypt
        const decrypted = CryptoJS.AES.decrypt(
            encryptedData,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        // Convert to UTF-8 string
        const plaintext = decrypted.toString(CryptoJS.enc.Utf8);

        return plaintext;
    },
    fetchOMSToken: async function () {
        try {
            const omsToken = await ServiceCalls.getOMSToken();
            if (omsToken.access_token && omsToken.pk) {
                const decryptedToken = this.decryptData(omsToken.access_token, omsToken.pk);
                omsToken.access_token = decryptedToken;
                return omsToken;
            }
        }
        catch (e) {
            const err = `Error in Fetching OMS Token. Ex: ${e}`;
            console.log(err);
            const erraudit = { message: err, severity: 'Exception' };
            await ServiceCalls.postAuditLog(erraudit);
            return null;
        }
    }
}

export default CommonUtils;